<template>
  <div class="hello">
    <div class="text-titel">{{ installlocation }}{{ data }}{{ data2 }}</div>
    <div class="box-button">
      <el-button type="primary" round @click="themebutton"
        >充&nbsp;&nbsp;&nbsp;&nbsp;电</el-button
      >
      <el-button type="primary" round @click="chargingRecordbutton"
        >充电记录</el-button
      >
    </div>
    <div class="box-box">
      <div
        v-for="(item, index) in realtimeValuedata"
        :key="index"
        style="
          margin: 1%;
          width: 29%;
          align-items: center;
          display: flex;
          flex-direction: column;
          border: 1px solid #566492;
        "
      >
        <div class="box-name">{{ item.devnode1desc }}</div>

        <div class="box-number">
          <div style="font-size: 15px">{{ item.val }}{{ item.devuint }}</div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogFormVisible">
      <div class="contentclass">
        <div class="text-box">手机号</div>
        <el-input v-model="form.applyPhone" autocomplete="off"></el-input>
      </div>
      <div class="contentclass">
        <div class="text-box">图片验证码</div>
        <div class="login-code" style="display: flex;">
          <el-input
            placeholder="请输入验证码"
            v-model="form.codes"
            maxlength="6"
          ></el-input>
          <img style="width: 80px;" :src="codeUrl" @click="getCodeUrl" />
        </div>
      </div>
      <div class="contentclass">
        <div class="text-box">验证码</div>
        <div style="display: flex; align-items: center">
          <el-input
            placeholder="请输入验证码"
            v-model="form.code"
            maxlength="6"
          >
          </el-input>
          <button
            style="width: 120px; margin-left: 20px"
            class="btn-code"
            @click="getCodebutton"
          >
            {{ count }}
          </button>
        </div>
      </div>
      <div class="contentclass">
        <div class="text-box">电量</div>

        <el-input v-model="form.name" autocomplete="off"></el-input>
      </div>
      <div class="contentclass">
        <div class="text-box">充值金额</div>
        <el-input
          v-model="form.moryer"
          autocomplete="off"
          :disabled="true"
        ></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          style="margin-bottom: 15px"
          >取 消</el-button
        >
        <el-button type="primary" @click="wxPayByh5">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { MessageBox } from "mint-ui";
import { webSocket } from "../../utils/socketconn2";

const TIME_COUNT = 60;
import wx from "weixin-js-sdk";
export default {
  components: { wx },
  name: "bindDetail",
  data() {
    return {
      data2: "",
      data: "",
      count: "获取验证码",
      realtimeValuedata: [],
      dialogFormVisible: false,
      form: {
        moryer: 0,
        name: "",
        applyPhone: "",
        code: "",
        codes: ""
      },
      recordsdata: {
        projId: "",
        devSysName: ""
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      isShow: false,
      request: {
        phone: "",
        openId: ""
      },
      titlelname: "",
      devIdpk: "",
      projId: "",
      devSignature: "",
      paydata: "",
      user: {},
      paramsdata: "",
      openId: "",
      corpId: "",
      value6: "",
      installlocation: "",
      codeUrl: "", //验证码图片
      codeKey: ""
    };
  },
  watch: {
    "form.name": function(newValue, oldValue) {
      this.amountToEle();
    }
  },
  mounted() {
    this.titlelname = this.$route.query.name;
    this.devIdpk = this.$route.query.devIdpk;
    this.projId = this.$route.query.projId;
    this.devSignature = this.$route.query.devSignature;
    this.installlocation = this.$route.query.installlocation;

    this.openId = this.$route.query.openId;
    this.corpId = this.$route.query.corpId;

    if (this.request.openId) {
      this.getUserInfo();
    }
    this.getCodeUrl();
    this.realtimeValue();
  },
  methods: {
    getCodeUrl() {
      var _t = this;
      this.common.doActionGet(
        _t.common.getCode,
        {},
        function(res) {
          if (res.code == 200 || res.code == 202) {
            _t.codeUrl = res.data.codeUrl;
            _t.codeKey = res.data.key;
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    getCodebutton() {
      var re = new RegExp(/^1\d{10}$/); //当使用构造函数创造正则对象时，需要常规的字符转义规则（在前面加反斜杠 \）
      if (!this.form.applyPhone.match(re)) {
        // MessageBox.alert("请输入11位手机号");
        this.$message("请输入11位手机号");
        return false;
      }
      var _t = this;
      _t.common.doAction(
        _t.common.smsCode,
        {
          mobile: _t.form.applyPhone,
          platformId: 1,
          userWay: "yff",
          captcha: _t.form.codes,
          key: _t.codeKey
        },
        function(res) {
          if (res.code != 200) {
            // MessageBox.alert(res.msg, "ERROR");
            _t.$message(res.msg);
          }
          if (!_t.timer) {
            _t.count = TIME_COUNT;
            _t.show = false;
            _t.timer = setInterval(() => {
              if (_t.count > 0 && _t.count <= TIME_COUNT) {
                _t.count--;
              } else {
                _t.count = "获取验证码";
                clearInterval(_t.timer);
                _t.timer = null;
              }
            }, 1000);
          }
        },
        "weixin"
      );
    },
    realtimeValue() {
      var _this = this;
      this.common.doActionGet(
        this.common.realtimeValue,
        { devIdpk: this.devIdpk },
        function(res) {
          console.log(res);
          if (res.code == 200) {
            _this.realtimeValuedata = res.data;
          } else if (res.code == 201) {
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    // 充电记录
    chargingRecordbutton() {
      this.$router.push({
        path: "/chargingRecord",
        query: {
          name: this.installlocation,
          projId: this.projId,
          devIdpk: this.devIdpk
        }
      });
    },
    // 金额转
    amountToEle() {
      var _this = this;
      this.common.doActionGet(
        this.common.eleToAmount,
        { ele: _this.form.name, projId: _this.projId },
        function(res) {
          console.log(res);
          if (res.code == 200) {
            _this.form.moryer = res.data;
            // _this.$message.success("支付成功！");
          } else if (res.code == 201) {
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    wxPayByh5() {
      this.dialogFormVisible = false;
      var _this = this;
      this.common.doAction(
        this.common.wxPayByh5,
        {
          projId: _this.projId,
          devIdpk: _this.devIdpk,
          devSignature: _this.devSignature,
          amount: _this.form.moryer,
          openId: _this.openId,
          corpId: _this.openId,
          applyPhone: _this.form.applyPhone,
          code: _this.form.code,
          rechargeVal: _this.form.name
        },
        function(res) {
          console.log(res);
          if (res.code == 200) {
            // _this.$router.push({
            //   path:res.data.h5_url
            // })
            // location.href = res.data.h5_url
            _this.value6 = res.data;
            webSocket(res.data.stamp, function(dat) {
              console.log(dat);

              if (dat.result_code == "SUCCESS") {
                _this.value = dat;
                _this.pollingdata(dat);
                // _this.installlocation = dat
                // _this.openFullScreen2();
              }
            });

            _this.paydata = res.data;
            _this.payWeixinJSBridge();
          } else if (res.code == 201) {
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
    },
    payWeixinJSBridge() {
      let timestamp = new Date().getTime();
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: this.paydata.appId, //公众号ID，由商户传入
          timeStamp: this.paydata.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: this.paydata.nonceStr, //随机串
          package: this.paydata.package,
          signType: this.paydata.signType, //微信签名方式：
          paySign: this.paydata.paySign //微信签名
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
    pollingdata(data) {
      const loading = this.$loading({
        lock: true,
        text: "充值中请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var _this = this;
      this.common.doActionGet(
        this.common.polling,
        { commandId: data.commandId, stamp: data.out_trade_no },
        function(res) {
          console.log(res);

          if (res.code == 201) {
            _this.lunxunOn = setTimeout(() => {
              _this.pollingdata(data);
            }, 1000);
          } else if (res.code == 200) {
            clearTimeout(_this.lunxunOn);
            _this.$message.success("支付成功！");
            loading.close();
          } else if (res.code == 400) {
            _this.wxPayRefund(data);
            _this.$message.success("支付失败稍后退款！");
            clearTimeout(_this.lunxunOn);
            loading.close();
          } else {
            _this.wxPayRefund(data);
            _this.$message.success("支付失败稍后退款！");
            clearTimeout(_this.lunxunOn);
            loading.close();
          }
        },
        "dd"
      );
    },
    wxPayRefund(data) {
      var _this = this;
      this.common.doAction(
        this.common.wxPayRefund,
        {
          rechargeId: data.rechargeId,
          projId: _this.projId,
          devIdpk: _this.devIdpk,
          devSignature: _this.devSignature
        },
        function(res) {
          console.log(res);
          _this.$message.success(res.msg);
        },
        "weixin"
      );
    },
    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: "充值中请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 1000);
    },
    returnbutton() {
      this.$router.push({
        path: "/dormitoryofficialHome"
      });
    },
    // 充值弹框
    themebutton() {
      // var _t = this;
      // _t.$router.push({
      //   path: "/bindDetail",
      //   query: _t.recordsdata,
      // });
      this.dialogFormVisible = true;
    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.bindIsOk,
        { openId: this.request.openId },
        function(res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user = res.data;
            _t.request.phone = res.data.userphone;
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId
            };
            _t.$router.push({
              path: "/bindPhone",
              query: query
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
      this.isShow = true;
    },
    unbindWeChat() {
      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then(action => {
          _t.common.doActionGet(
            _t.common.removeBindLny,
            _t.request,
            function(res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch(_ => {});
    }
  }
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";

.hello {
  height: 100%;
  padding: 0px 20px;
  margin-top: -40px;
}

.title1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 20px;
}

.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 75px;
  text-align: left;
}

.tip {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 14px;
}

.btn-code {
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
}

.btn-gray {
  width: 100%;
  height: 40px;
  margin-top: 100px;
}

.wechat-user-logo {
  margin-top: 80px;
}

.box-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.box-one {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

/* .text-titel {
  width: 100%;
  padding: 20px 0px;
  font-size: 20px;
} */
.text-titel {
  width: 100%;
  padding: 50px 0px 10px;
  font-size: 20px;
}

.box-button {
  margin-bottom: 10%;
  display: flex;
}

.box-return {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  justify-content: space-around;
}

.box-name {
  width: 100px;
  height: 40px;
  /* background: #141c35; */
  /* border: 1px solid #566492; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-number {
  display: flex;
  align-items: center;
  /* background: rgb(30, 40, 69); */
  /* border: 1px solid rgb(86, 100, 146); */
  height: 40px;
  width: 30px;
  justify-content: center;
  flex-direction: column;
  /* justify-content: flex-start; */
}

.text-box {
  display: flex;
  justify-content: flex-start;
}

.contentclass {
  margin-bottom: 15px;
}
</style>
<style>
.el-dialog {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/dormitoryofficial/deviceDetails.vue